import { isBusyError } from '../api/busyRetry'
import { STATUS_COPY } from '../copy/status'

/**
 * The line a failed write shows (#392, owner ruling CAP-O26).
 *
 * A write is never sent again on its own (a 503 can arrive after part of its
 * work was done: `api/busyRetry.ts`), so when the server was busy the reader is
 * the one who asks again, and the line says so: "Busy right now. Try again in a
 * moment." It takes the place of the caller's generic line ("Save failed. Check
 * your connection and retry." and its siblings) **only when the error carries
 * the busy marker**: a busy server is not a bad connection, and "check your
 * connection" would send the reader to look in the wrong place. Any other
 * failure keeps the caller's own words, whatever they were.
 *
 * Callers pass their mutation's `error` object, not its `isError` flag: a flag
 * cannot say what kind of failure it was.
 */
export function writeErrorLine(error: unknown, generic: string): string {
  return isBusyError(error) ? STATUS_COPY.busyWrite : generic
}
